import { PatientType } from './Patient'

export enum BookingFor {
  BOOKING_FOR_ME = 'BOOKING_FOR_ME',
  BOOKING_FOR_OTHER = 'BOOKING_FOR_OTHER',
}

export interface BookingForOption extends PatientType {
  identifier: BookingFor
}
